import { render, staticRenderFns } from "./NormalSearchNav122.vue?vue&type=template&id=b887912c&scoped=true&"
import script from "./NormalSearchNav122.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav122.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b887912c",
  null
  
)

export default component.exports